import { useEffect, useState } from 'react';
import { useIoContext } from '~/contexts';
import { easeOutCubic } from '../../RevenueOpportunitiesSection.utils';
const TALLY_TARGET = 2480;
const TALLY_STEPS = 24;
const STEP_MS = 80;
const HOLD_MS = 2000;
export const useTallyCount = ()=>{
    const { browser } = useIoContext();
    const [step, setStep] = useState(0);
    useEffect(()=>{
        if (!browser.prefersReducedMotion()) {
            return browser.schedule(step < TALLY_STEPS ? STEP_MS : HOLD_MS, ()=>setStep((current)=>current < TALLY_STEPS ? current + 1 : 0));
        }
    }, [
        step
    ]);
    const progress = step / TALLY_STEPS;
    return Math.round(TALLY_TARGET * easeOutCubic(progress));
};
